import * as types from "../mutation-types";

// state
export const state = {
    fixedToasts:0,
    content:[]
};

// getters
export const getters = {
  fixedToasts: state => state.fixedToasts,
  content: state => state.content,
};

// mutations
export const mutations = {
  [types.ADD_FIXED_TOASTS](state, { body, header, color, outline }) {
    state.fixedToasts ++;
    state.content.push({  body, header, color, outline });
  },
  [types.RESET_FIXED_TOASTS](state, { }) {
    state.fixedToasts ++;
    state.content = [];
  }

};

// actions
export const actions = {
  addFixedToasts({ commit }, payload = {} ) {
    commit(types.ADD_FIXED_TOASTS, payload);
  },
  resetFixedToasts({ commit }, payload = {}) {
    commit(types.RESET_FIXED_TOASTS, payload);
  },
};